/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface ScreenerBedUnit
 */
export interface ScreenerBedUnit {
    /**
     * 
     * @type {string}
     * @memberof ScreenerBedUnit
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerBedUnit
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerBedUnit
     */
    name: string;
    /**
     * 
     * @type {Array<ScreenerBedRoom>}
     * @memberof ScreenerBedUnit
     */
    rooms?: Array<ScreenerBedRoom>;
}

/**
 * Check if a given object implements the ScreenerBedUnit interface.
 */
export function instanceOfScreenerBedUnit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ScreenerBedUnitFromJSON(json: any): ScreenerBedUnit {
    return ScreenerBedUnitFromJSONTyped(json, false);
}

export function ScreenerBedUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerBedUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'name': json['name'],
        'rooms': !exists(json, 'rooms') ? undefined : ((json['rooms'] as Array<any>).map(ScreenerBedRoomFromJSON)),
    };
}

export function ScreenerBedUnitToJSON(value?: ScreenerBedUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'name': value.name,
        'rooms': value.rooms === undefined ? undefined : ((value.rooms as Array<any>).map(ScreenerBedRoomToJSON)),
    };
}

